import React from "react";
import styled from "@emotion/styled";

import { AccountBalanceWallet as WalletIcon, Refresh as RefreshIcon } from "@mui/icons-material";
import { Box, Typography, Tooltip, CircularProgress } from "@mui/material";

import { roundOff } from "../../../utils/common";

const WalletWidget = styled(Box)`
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%);
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
    background: linear-gradient(135deg, #4338ca 0%, #2563eb 100%);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
    pointer-events: none;
  }
`;

const IconWrapper = styled(Box)`
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
`;

function Actions({ walletBalance, fetchTenantData, fetchDashboardData, loading }) {
  const refreshDashboard = () => {
    fetchTenantData();
    fetchDashboardData();
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Tooltip title="Wallet Balance">
        <WalletWidget onClick={refreshDashboard}>
          <IconWrapper>
            <WalletIcon sx={{ fontSize: 20 }} />
          </IconWrapper>
          <Box>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                color: "rgba(255, 255, 255, 0.7)",
                textTransform: "uppercase",
                fontWeight: 600,
                fontSize: "0.65rem",
                letterSpacing: "0.05em",
                mb: -0.5,
              }}
            >
              Balance
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                letterSpacing: "0.02em",
                fontSize: "1rem",
              }}
            >
              ₹ {roundOff(walletBalance)}
            </Typography>
          </Box>
          <Box
            sx={{
              ml: 2,
              pl: 2,
              borderLeft: "1px solid rgba(255, 255, 255, 0.2)",
              display: "flex",
              alignItems: "center",
            }}
          >
            {loading ? (
              <CircularProgress size={16} sx={{ color: "#fff" }} />
            ) : (
              <RefreshIcon
                sx={{
                  fontSize: 18,
                  opacity: 0.8,
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "rotate(180deg)", opacity: 1 },
                }}
              />
            )}
          </Box>
        </WalletWidget>
      </Tooltip>
    </Box>
  );
}

export default Actions;
